import { LinkedCodeRow } from '../../features/pricebook/types/linkedCode';

interface LinkedCodeServerData {
  id?: string | null;
  store_id?: string | null;
  scan_code?: string | null;
  item_name?: string | null;
  status?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

class LinkedCodeModel {
  private _serverData: any;

  constructor(serverData: any = null) {
    this._serverData = serverData;
  }

  get id() {
    return String((this._serverData as LinkedCodeServerData)?.id ?? '').trim();
  }

  get store_id() {
    return String((this._serverData as LinkedCodeServerData)?.store_id ?? '').trim();
  }

  get scan_code() {
    return String((this._serverData as LinkedCodeServerData)?.scan_code ?? '').trim();
  }

  get item_name() {
    return String((this._serverData as LinkedCodeServerData)?.item_name ?? '').trim();
  }

  get status() {
    return String((this._serverData as LinkedCodeServerData)?.status ?? '').trim();
  }

  getRawData() {
    return this._serverData;
  }

  toRowFormat(): LinkedCodeRow {
    return {
      id: this.id || `${this.store_id}-${this.scan_code}`,
      scanCode: this.scan_code || '-',
      itemName: this.item_name || '-',
      status: this.status || '-',
    };
  }

  static fromServerData(serverData: any) {
    return new LinkedCodeModel(serverData);
  }
}

class LinkedCodeListModel {
  private _items: LinkedCodeModel[];
  private _storeId: string;

  constructor(serverData: any = null) {
    this._storeId = String(serverData?.store_id ?? '').trim();

    if (serverData && Array.isArray(serverData.items)) {
      this._items = serverData.items.map((item: any) => LinkedCodeModel.fromServerData(item));
      return;
    }

    this._items = [];
  }

  get storeId() {
    return this._storeId;
  }

  get items() {
    return this._items;
  }

  toRowFormat() {
    return this._items.map((item) => item.toRowFormat());
  }

  getRawData() {
    return this._items.map((item) => item.getRawData());
  }

  static fromServerData(serverData: any) {
    return new LinkedCodeListModel(serverData);
  }

  static createEmpty() {
    return new LinkedCodeListModel();
  }
}

export default LinkedCodeModel;
export { LinkedCodeListModel };
